import React from 'react';
import { 
    Box, 
    Typography, 
    Button, 
    Badge, 
    ThemeProvider 
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import FilterListIcon from '@mui/icons-material/FilterList';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DateFilter from '../DateFilter';
import { darkTheme } from './theme';

/**
 * Dashboard Header Component
 * @param {Object} props - Component props
 * @param {Object} props.dateRange - Current date range
 * @param {Function} props.onDateRangeChange - Callback when date range changes
 * @param {Function} props.onRefresh - Callback when refresh button is clicked
 * @param {boolean} props.showLowPerformance - Whether low performance filter is active
 * @param {Function} props.onToggleLowPerformance - Callback to toggle low performance filter
 * @param {number} props.lowPerformanceCount - Count of low performance campaigns
 */
const DashboardHeader = ({ 
    dateRange, 
    onDateRangeChange, 
    onRefresh, 
    showLowPerformance, 
    onToggleLowPerformance, 
    lowPerformanceCount 
}) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'white' }}>
                Media Buying Dashboard
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <ThemeProvider theme={darkTheme}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Box sx={{ 
                            mr: 2, 
                            display: 'flex', 
                            alignItems: 'center',
                            bgcolor: 'rgba(30, 33, 48, 0.8)',
                            p: '4px 8px',
                            borderRadius: '8px',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                        }}>
                            <DateFilter 
                                dateRange={dateRange}
                                onDateRangeChange={onDateRangeChange}
                            />
                        </Box>
                    </LocalizationProvider>
                </ThemeProvider>
                <Button 
                    variant="contained" 
                    color="primary" 
                    startIcon={<RefreshIcon />}
                    onClick={onRefresh}
                    sx={{ 
                        mr: 2, 
                        bgcolor: '#1e2130',
                        '&:hover': {
                            bgcolor: '#2c3040',
                        },
                        boxShadow: '0 4px 10px rgba(0,0,0,0.15)'
                    }}
                >
                    Refresh
                </Button>
                
            </Box>
        </Box>
    );
};

export default DashboardHeader; 